// 背景
export const blackColor = '#26211E';
export const contentWrapColor = '#2E2E2E';
// 文字
export const fontColorWhite = '#E6E9EA';


////////// ルート //////////
export const routeTop = '/';
export const routeTopJa = '/ja';
export const routeTopPt = '/pt';
export const routeTopEs = '/es';
export const routeTopKo = '/ko';
export const routeTopHi = '/hi';
export const routeTopPl = '/pl';
export const routeAppApi = '/app';
export const routeTermOfService = '/term_of_service';
export const routePrivacyPolicy = '/privacy_policy';
export const routeTokutei = '/tokutei';
export const routeContact = '/contact';
export const routeContactDone = '/contact/done';